<template>
  <div
    class="flex absolute z-30 flex-col justify-end justify-between items-center w-full antialiased text-primary">
    <div class="flex justify-center px-8">
      <transition name="flip" mode="out-in" appear>
        <ul class="absolute bottom-2 px-4 space-y-2 w-full md:bottom-0">
          <transition name="flip" mode="out-in" appear>
            <router-link class="transform rotate-3 translate-y-8 bg-primary" :to="{name: 'About'}" tag="li"
                         exact-active-class="text-secondary bg-secondary">
              <a
                class="flex items-center p-4 rounded-lg border ring-2 bg-primary hover:bg-secondary active:bg-secondary hover:text-secondary focus:text-secondary shadow-cst_lg ring-cst_lg">
                <i class="text-lg fas fa-info-circle"></i>
                <span class="ml-2">About</span>
              </a>
            </router-link>
          </transition>
          <transition name="flip" mode="out-in" appear>
            <router-link class="transform rotate-6 translate-y-8 bg-primary active:bg-secondary" :to="{name: 'Projects'}" tag="button"
                         exact-active-class="text-secondary">
              <a
                class="flex items-center p-4 rounded-lg border ring-2 bg-primary hover:bg-secondary hover:text-secondary focus:text-secondary shadow-cst_lg ring-cst_lg">
                <i class="text-lg fas fa-project-diagram"></i>
                <span class="ml-2">Projects</span>
              </a>
            </router-link>
          </transition>
          <transition name="flip" mode="out-in" appear>
            <router-link class="transform rotate-3 translate-y-8 bg-primary active:bg-secondary" :to="{name: 'Contact'}" tag="button"
                         exact-active-class="text-secondary">
              <a
                class="flex items-center p-4 rounded-lg border ring-2 bg-primary hover:bg-secondary hover:text-secondary focus:text-secondary shadow-cst_lg ring-cst_lg">
                <i class="text-lg fas fa-address-book"></i>
                <span class="ml-2">Contact</span>
              </a>
            </router-link>
          </transition>
          <transition name="flip" mode="out-in" appear>
            <router-link class="transform rotate-3 translate-y-8 bg-primary active:bg-secondary" :to="{name: 'CV'}" tag="button"
                         exact-active-class="text-secondary">
              <a rel="noreferrer"
                class="flex items-center p-4 rounded-lg border ring-2 bg-primary hover:bg-secondary hover:text-secondary focus:text-secondary shadow-cst_lg ring-cst_lg">
                <i class="text-lg fas fa-file-contract"></i>
                <span class="ml-2">Resume</span>
              </a>
            </router-link>
          </transition>
        </ul>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileMenu'
}
</script>

<style scoped>
.flip-enter-active {
  transition: all 1s ease-in-out;
}

.flip-leave-active {
  transition: all 1s ease-in-out;
}

.flip-enter-from, .flip-leave-to {
  transform: translate(0px, 100px) rotate(-45deg);
  opacity: 0.5;
}
</style>
